import { Box, Card, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PublicArticleJaaAd() {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ marginX: { xs: -2, sm: 0 } }}>
        <Box
          sx={{
            backgroundImage: `url("/desk.png")`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            height: { xs: '300px', sm: '400px' },
            maxWidth: '100%',
          }}
        />
      </Box>
      <Card
        elevation={6}
        sx={{
          paddingY: { xs: 2, md: 3 },
          paddingX: { xs: 2, sm: 4, md: 8 },
          position: 'relative',
          top: { xs: '-10rem', md: '-8rem' },
          left: { xs: 0, sm: '2rem', md: '4rem' },
          marginRight: { xs: 0, sm: '4rem', md: '8rem' },
          marginBottom: { xs: '-10rem', md: '-8rem' },
        }}
      >
        <Typography
          variant='h2'
          sx={{
            paddingY: 1,
          }}
        >
          {t('marketing.title')}
        </Typography>
        <Typography
          variant='body2'
          sx={{
            paddingY: 1,
          }}
        >
          {t('marketing.description')}
        </Typography>
        <Link
          variant='body2'
          underline='hover'
          href='https://www.almainsights.fi/kaikki-tuotteet-ja-palvelut/juridiikan-ajankohtaiset/'
          sx={{
            paddingTop: 2,
            paddingBottom: 1,
          }}
        >
          {t('marketing.cta')}
        </Link>
      </Card>
    </>
  );
}
